<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  /** Adds the hover elevation and primary border highlight. */
  interactive?: boolean;
  /** Marks the card as chosen with a solid brand border. */
  selected?: boolean;
  /** Renders the dashed empty tile used by dashboard section slots. */
  placeholder?: boolean;
};

const props = defineProps<Props>();

const BASE_CLASS =
  'relative flex h-full min-h-[15rem] w-full flex-col gap-lg rounded-md border p-lg';

const cardClass = computed(() => {
  if (props.placeholder) {
    return [
      BASE_CLASS,
      'border-dashed border-line',
      props.interactive && 'transition-colors hover:border-primary',
    ];
  }

  return [
    BASE_CLASS,
    'bg-surface-container shadow-sm',
    // `ring-inset` thickens the 1px border to the 2px brand accent without the
    // layout shift a `border-2` swap would cause.
    props.selected
      ? 'border-primary ring-1 ring-primary ring-inset'
      : 'border-line',
    props.interactive &&
      'transition-shadow hover:border-primary hover:shadow-md',
  ];
});
</script>

<template>
  <div :class="cardClass">
    <slot name="controls" />
    <slot />
  </div>
</template>
